import { render } from "./PatientResults.vue?vue&type=template&id=6c14d958&ts=true"
import script from "./PatientResults.vue?vue&type=script&lang=ts"
export * from "./PatientResults.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__